import americanFootballSvg from '../../assets/icons/sports/american-football/americanFootball.svg';
import americanFootballGreySvg from '../../assets/icons/sports/american-football/americanFootballGrey.svg';
import americanFootballOrangeSvg from '../../assets/icons/sports/american-football/americanFootballOrange.svg';
import americanFootballPurpleSvg from '../../assets/icons/sports/american-football/americanFootballPurple.svg';
import americanFootballWhiteSvg from '../../assets/icons/sports/american-football/americanFootballWhite.svg';
import baseballSvg from '../../assets/icons/sports/baseball/baseball.svg';
import baseballGreySvg from '../../assets/icons/sports/baseball/baseballGrey.svg';
import baseballOrangeSvg from '../../assets/icons/sports/baseball/baseballOrange.svg';
import baseballPurpleSvg from '../../assets/icons/sports/baseball/baseballPurple.svg';
import baseballWhiteSvg from '../../assets/icons/sports/baseball/baseballWhite.svg';
import basketballSvg from '../../assets/icons/sports/basketball/basketball.svg';
import basketballGreySvg from '../../assets/icons/sports/basketball/basketballGrey.svg';
import basketballOrangeSvg from '../../assets/icons/sports/basketball/basketballOrange.svg';
import basketballPurpleSvg from '../../assets/icons/sports/basketball/basketballPurple.svg';
import basketballWhiteSvg from '../../assets/icons/sports/basketball/basketballWhite.svg';
import boxingSvg from '../../assets/icons/sports/boxing/boxing.svg';
import boxingGreySvg from '../../assets/icons/sports/boxing/boxingGrey.svg';
import boxingOrangeSvg from '../../assets/icons/sports/boxing/boxingOrange.svg';
import boxingPurpleSvg from '../../assets/icons/sports/boxing/boxingPurple.svg';
import boxingWhiteSvg from '../../assets/icons/sports/boxing/boxingWhite.svg';
import cricketSvg from '../../assets/icons/sports/cricket/cricket.svg';
import cricketGreySvg from '../../assets/icons/sports/cricket/cricketGrey.svg';
import cricketOrangeSvg from '../../assets/icons/sports/cricket/cricketOrange.svg';
import cricketPurpleSvg from '../../assets/icons/sports/cricket/cricketPurple.svg';
import cricketWhiteSvg from '../../assets/icons/sports/cricket/cricketWhite.svg';
import dartsSvg from '../../assets/icons/sports/darts/darts.svg';
import dartsGreySvg from '../../assets/icons/sports/darts/dartsGrey.svg';
import dartsOrangeSvg from '../../assets/icons/sports/darts/dartsOrange.svg';
import dartsPurpleSvg from '../../assets/icons/sports/darts/dartsPurple.svg';
import dartsWhiteSvg from '../../assets/icons/sports/darts/dartsWhite.svg';
import eleaguesSvg from '../../assets/icons/sports/e-leagues/eleagues.svg';
import eleaguesGreySvg from '../../assets/icons/sports/e-leagues/eleaguesGrey.svg';
import eleaguesOrangeSvg from '../../assets/icons/sports/e-leagues/eleaguesOrange.svg';
import eleaguesPurpleSvg from '../../assets/icons/sports/e-leagues/eleaguesPurple.svg';
import eleaguesWhiteSvg from '../../assets/icons/sports/e-leagues/eleaguesWhite.svg';
import f1Svg from '../../assets/icons/sports/f1/f1.svg';
import f1GreySvg from '../../assets/icons/sports/f1/f1Grey.svg';
import f1OrangeSvg from '../../assets/icons/sports/f1/f1Orange.svg';
import f1PurpleSvg from '../../assets/icons/sports/f1/f1Purple.svg';
import f1WhiteSvg from '../../assets/icons/sports/f1/f1White.svg';
import featuredSvg from '../../assets/icons/sports/featured/featured.svg';
import featuredGreySvg from '../../assets/icons/sports/featured/featuredGrey.svg';
import featuredOrangeSvg from '../../assets/icons/sports/featured/featuredOrange.svg';
import featuredPurpleSvg from '../../assets/icons/sports/featured/featuredPurple.svg';
import footballSvg from '../../assets/icons/sports/football/football.svg';
import footballGreySvg from '../../assets/icons/sports/football/footballGrey.svg';
import footballOrangeSvg from '../../assets/icons/sports/football/footballOrange.svg';
import footballPurpleSvg from '../../assets/icons/sports/football/footballPurple.svg';
import footballWhiteSvg from '../../assets/icons/sports/football/footballWhite.svg';
import golfSvg from '../../assets/icons/sports/golf/golf.svg';
import golfGreySvg from '../../assets/icons/sports/golf/golfGrey.svg';
import golfOrangeSvg from '../../assets/icons/sports/golf/golfOrange.svg';
import golfPurpleSvg from '../../assets/icons/sports/golf/golfPurple.svg';
import golfWhiteSvg from '../../assets/icons/sports/golf/golfWhite.svg';
import greyhoundsSvg from '../../assets/icons/sports/greyhounds/greyhounds.svg';
import greyhoundsGreySvg from '../../assets/icons/sports/greyhounds/greyhoundsGrey.svg';
import greyhoundsOrangeSvg from '../../assets/icons/sports/greyhounds/greyhoundsOrange.svg';
import greyhoundsPurpleSvg from '../../assets/icons/sports/greyhounds/greyhoundsPurple.svg';
import greyhoundsWhiteSvg from '../../assets/icons/sports/greyhounds/greyhoundsWhite.svg';
import horseRacingSvg from '../../assets/icons/sports/horse-racing/horseRacing.svg';
import horseRacingGreySvg from '../../assets/icons/sports/horse-racing/horseRacingGrey.svg';
import horseRacingOrangeSvg from '../../assets/icons/sports/horse-racing/horseRacingOrange.svg';
import horseRacingPurpleSvg from '../../assets/icons/sports/horse-racing/horseRacingPurple.svg';
import horseRacingWhiteSvg from '../../assets/icons/sports/horse-racing/horseRacingWhite.svg';
import iceHockeySvg from '../../assets/icons/sports/ice-hockey/iceHockey.svg';
import iceHockeyGreySvg from '../../assets/icons/sports/ice-hockey/iceHockeyGrey.svg';
import iceHockeyOrangeSvg from '../../assets/icons/sports/ice-hockey/iceHockeyOrange.svg';
import iceHockeyPurpleSvg from '../../assets/icons/sports/ice-hockey/iceHockeyPurple.svg';
import iceHockeyWhiteSvg from '../../assets/icons/sports/ice-hockey/iceHockeyWhite.svg';
import inPlaySvg from '../../assets/icons/sports/in-play/inPlay.svg';
import inPlayGreySvg from '../../assets/icons/sports/in-play/inPlayGrey.svg';
import inPlayOrangeSvg from '../../assets/icons/sports/in-play/inPlayOrange.svg';
import inPlayPurpleSvg from '../../assets/icons/sports/in-play/inPlayPurple.svg';
import mmaSvg from '../../assets/icons/sports/mma/mma.svg';
import mmaGreySvg from '../../assets/icons/sports/mma/mmaGrey.svg';
import mmaOrangeSvg from '../../assets/icons/sports/mma/mmaOrange.svg';
import mmaPurpleSvg from '../../assets/icons/sports/mma/mmaPurple.svg';
import mmaWhiteSvg from '../../assets/icons/sports/mma/mmaWhite.svg';
import promotionsSvg from '../../assets/icons/sports/promotions/promotions.svg';
import promotionsGreySvg from '../../assets/icons/sports/promotions/promotionsGrey.svg';
import promotionsOrangeSvg from '../../assets/icons/sports/promotions/promotionsOrange.svg';
import promotionsPurpleSvg from '../../assets/icons/sports/promotions/promotionsPurple.svg';
import rugbySvg from '../../assets/icons/sports/rugby/rugby.svg';
import rugbyGreySvg from '../../assets/icons/sports/rugby/rugbyGrey.svg';
import rugbyOrangeSvg from '../../assets/icons/sports/rugby/rugbyOrange.svg';
import rugbyPurpleSvg from '../../assets/icons/sports/rugby/rugbyPurple.svg';
import rugbyWhiteSvg from '../../assets/icons/sports/rugby/rugbyWhite.svg';
import snookerSvg from '../../assets/icons/sports/snooker/snooker.svg';
import snookerGreySvg from '../../assets/icons/sports/snooker/snookerGrey.svg';
import snookerOrangeSvg from '../../assets/icons/sports/snooker/snookerOrange.svg';
import snookerPurpleSvg from '../../assets/icons/sports/snooker/snookerPurple.svg';
import snookerWhiteSvg from '../../assets/icons/sports/snooker/snookerWhite.svg';
import tableTennisSvg from '../../assets/icons/sports/table-tennis/tableTennis.svg';
import tableTennisGreySvg from '../../assets/icons/sports/table-tennis/tableTennisGrey.svg';
import tableTennisOrangeSvg from '../../assets/icons/sports/table-tennis/tableTennisOrange.svg';
import tableTennisPurpleSvg from '../../assets/icons/sports/table-tennis/tableTennisPurple.svg';
import tableTennisWhiteSvg from '../../assets/icons/sports/table-tennis/tableTennisWhite.svg';
import tennisSvg from '../../assets/icons/sports/tennis/tennis.svg';
import tennisGreySvg from '../../assets/icons/sports/tennis/tennisGrey.svg';
import tennisOrangeSvg from '../../assets/icons/sports/tennis/tennisOrange.svg';
import tennisPurpleSvg from '../../assets/icons/sports/tennis/tennisPurple.svg';
import tennisWhiteSvg from '../../assets/icons/sports/tennis/tennisWhite.svg';
import volleyballSvg from '../../assets/icons/sports/volleyball/volleyball.svg';
import volleyballGreySvg from '../../assets/icons/sports/volleyball/volleyballGrey.svg';
import volleyballOrangeSvg from '../../assets/icons/sports/volleyball/volleyballOrange.svg';
import volleyballPurpleSvg from '../../assets/icons/sports/volleyball/volleyballPurple.svg';
import volleyballWhiteSvg from '../../assets/icons/sports/volleyball/volleyballWhite.svg';
import { AcceptedCountries } from '../international/internationalEnums';
import { LIST_TYPE } from './sportsEnums';
import { Category, Detail, FeaturedCategory, FeaturedDetail, MarketOfferGroup, Status } from './sportsInterfaces';

export const DEFAULT_MIN_BET_AMOUNT = 0.1;

// Sport categories and IDs
export const sportCategories: Category = {
  FOOTBALL: 11,
  TENNIS: 15,
  HORSES: 200,
  CRICKET: 10,
  RUGBY: 6,
  DARTS: 5,
  SNOOKER: 4,
  BOXING: 20,
  MMA: 126,
  BASKETBALL: 12,
  ICE_HOCKEY: 8,
  AMERICAN_FOOTBALL: 7,
  FOOTBALL_LEGACY: 1,
  GREY_HOUNDS: 13,
  TABLE_TENNIS: 14,
  BASEBALL: 16,
  VOLLEYBALL: 500,
  GOLF: 600,
  F1: 700,
  ELEAGUES: 1000,
  E_FOOTBALL: 800,
  E_BASKETBALL: 900,
  ALL: 0,
};

export const sportIdsLegacyToNew = {
  [sportCategories.FOOTBALL]: 1,
  [sportCategories.HORSES]: 2,
  [sportCategories.TENNIS]: 3,
  [sportCategories.CRICKET]: 4,
  [sportCategories.BASKETBALL]: 5,
  [sportCategories.AMERICAN_FOOTBALL]: 6,
  [sportCategories.RUGBY]: 7,
  [sportCategories.DARTS]: 8,
  [sportCategories.SNOOKER]: 9,
  [sportCategories.BOXING]: 10,
  [sportCategories.MMA]: 11,
  [sportCategories.ICE_HOCKEY]: 12,
  [sportCategories.GREY_HOUNDS]: 13,
  [sportCategories.TABLE_TENNIS]: 14,
  [sportCategories.BASEBALL]: 15,
  [sportCategories.VOLLEYBALL]: 16,
  [sportCategories.GOLF]: 17,
  [sportCategories.F1]: 18,
  [sportCategories.ELEAGUES]: 1000,
  [sportCategories.E_FOOTBALL]: 19,
  [sportCategories.E_BASKETBALL]: 20,
};

export const sportIdsNewToLegacy: { [key: number]: number } = {
  1: sportCategories.FOOTBALL,
  2: sportCategories.HORSES,
  3: sportCategories.TENNIS,
  4: sportCategories.CRICKET,
  5: sportCategories.BASKETBALL,
  6: sportCategories.AMERICAN_FOOTBALL,
  7: sportCategories.RUGBY,
  8: sportCategories.DARTS,
  9: sportCategories.SNOOKER,
  10: sportCategories.BOXING,
  11: sportCategories.MMA,
  12: sportCategories.ICE_HOCKEY,
  13: sportCategories.GREY_HOUNDS,
  14: sportCategories.TABLE_TENNIS,
  15: sportCategories.BASEBALL,
  16: sportCategories.VOLLEYBALL,
  17: sportCategories.GOLF,
  18: sportCategories.F1,
  1000: sportCategories.ELEAGUES,
  19: sportCategories.E_FOOTBALL,
  20: sportCategories.E_BASKETBALL,
};

// Featured/Unique categories and IDs
export const featuredCategories: FeaturedCategory = {
  IN_PLAY: 'live-now',
  FEATURED: 'default',
  PROMOTIONS: 'promos',
  IN_PLAY_24_HOURS: 'inplay_24hrs',
};

// Featured/Unique category details
export const featuredCategoryDetails: FeaturedDetail = {
  [featuredCategories.IN_PLAY]: {
    id: featuredCategories.IN_PLAY,
    nameId: 'sports.in_play',
    purpleSvg: inPlayPurpleSvg,
    greySvg: inPlayGreySvg,
    svg: inPlaySvg,
    orangeSvg: inPlayOrangeSvg,
  },
  [featuredCategories.PROMOTIONS]: {
    id: featuredCategories.PROMOTIONS,
    nameId: 'common.promotions',
    purpleSvg: promotionsPurpleSvg,
    greySvg: promotionsGreySvg,
    svg: promotionsSvg,
    orangeSvg: promotionsOrangeSvg,
  },
  [featuredCategories.FEATURED]: {
    id: featuredCategories.FEATURED,
    nameId: 'common.featured',
    purpleSvg: featuredPurpleSvg,
    greySvg: featuredGreySvg,
    svg: featuredSvg,
    orangeSvg: featuredOrangeSvg,
  },
};

// Sport category details
export const sportCategoryDetails: Detail = {
  [sportCategories.FOOTBALL]: {
    id: sportCategories.FOOTBALL,
    nameId: 'sports.football',
    purpleSvg: footballPurpleSvg,
    greySvg: footballGreySvg,
    whiteSvg: footballWhiteSvg,
    svg: footballSvg,
    orangeSvg: footballOrangeSvg,
  },
  [sportCategories.FOOTBALL_LEGACY]: {
    id: sportCategories.FOOTBALL_LEGACY,
    nameId: 'sports.football',
    purpleSvg: footballPurpleSvg,
    greySvg: footballGreySvg,
    whiteSvg: footballWhiteSvg,
    svg: footballSvg,
    orangeSvg: footballOrangeSvg,
  },
  [sportCategories.TENNIS]: {
    id: sportCategories.TENNIS,
    nameId: 'sports.tennis',
    purpleSvg: tennisPurpleSvg,
    greySvg: tennisGreySvg,
    whiteSvg: tennisWhiteSvg,
    svg: tennisSvg,
    orangeSvg: tennisOrangeSvg,
  },
  [sportCategories.HORSES]: {
    id: sportCategories.HORSES,
    nameId: 'sports.horses',
    purpleSvg: horseRacingPurpleSvg,
    greySvg: horseRacingGreySvg,
    whiteSvg: horseRacingWhiteSvg,
    svg: horseRacingSvg,
    orangeSvg: horseRacingOrangeSvg,
  },
  [sportCategories.CRICKET]: {
    id: sportCategories.CRICKET,
    nameId: 'sports.cricket',
    purpleSvg: cricketPurpleSvg,
    greySvg: cricketGreySvg,
    whiteSvg: cricketWhiteSvg,
    svg: cricketSvg,
    orangeSvg: cricketOrangeSvg,
  },
  [sportCategories.RUGBY]: {
    id: sportCategories.RUGBY,
    nameId: 'sports.rugby',
    purpleSvg: rugbyPurpleSvg,
    greySvg: rugbyGreySvg,
    whiteSvg: rugbyWhiteSvg,
    svg: rugbySvg,
    orangeSvg: rugbyOrangeSvg,
  },
  [sportCategories.AMERICAN_FOOTBALL]: {
    id: sportCategories.AMERICAN_FOOTBALL,
    nameId: 'sports.american_football',
    purpleSvg: americanFootballPurpleSvg,
    greySvg: americanFootballGreySvg,
    whiteSvg: americanFootballWhiteSvg,
    svg: americanFootballSvg,
    orangeSvg: americanFootballOrangeSvg,
  },
  [sportCategories.DARTS]: {
    id: sportCategories.DARTS,
    nameId: 'sports.darts',
    purpleSvg: dartsPurpleSvg,
    greySvg: dartsGreySvg,
    whiteSvg: dartsWhiteSvg,
    svg: dartsSvg,
    orangeSvg: dartsOrangeSvg,
  },
  [sportCategories.SNOOKER]: {
    id: sportCategories.SNOOKER,
    nameId: 'sports.snooker',
    purpleSvg: snookerPurpleSvg,
    greySvg: snookerGreySvg,
    whiteSvg: snookerWhiteSvg,
    svg: snookerSvg,
    orangeSvg: snookerOrangeSvg,
  },
  [sportCategories.BOXING]: {
    id: sportCategories.BOXING,
    nameId: 'sports.boxing',
    purpleSvg: boxingPurpleSvg,
    greySvg: boxingGreySvg,
    whiteSvg: boxingWhiteSvg,
    svg: boxingSvg,
    orangeSvg: boxingOrangeSvg,
  },
  [sportCategories.MMA]: {
    id: sportCategories.MMA,
    nameId: 'sports.mma',
    purpleSvg: mmaPurpleSvg,
    greySvg: mmaGreySvg,
    whiteSvg: mmaWhiteSvg,
    svg: mmaSvg,
    orangeSvg: mmaOrangeSvg,
  },
  [sportCategories.BASKETBALL]: {
    id: sportCategories.BASKETBALL,
    nameId: 'sports.basketball',
    purpleSvg: basketballPurpleSvg,
    greySvg: basketballGreySvg,
    whiteSvg: basketballWhiteSvg,
    svg: basketballSvg,
    orangeSvg: basketballOrangeSvg,
  },
  [sportCategories.ICE_HOCKEY]: {
    id: sportCategories.ICE_HOCKEY,
    nameId: 'sports.ice_hockey',
    purpleSvg: iceHockeyPurpleSvg,
    greySvg: iceHockeyGreySvg,
    whiteSvg: iceHockeyWhiteSvg,
    svg: iceHockeySvg,
    orangeSvg: iceHockeyOrangeSvg,
  },
  [sportCategories.BASEBALL]: {
    id: sportCategories.BASEBALL,
    nameId: 'sports.baseball',
    purpleSvg: baseballPurpleSvg,
    greySvg: baseballGreySvg,
    whiteSvg: baseballWhiteSvg,
    svg: baseballSvg,
    orangeSvg: baseballOrangeSvg,
  },
  [sportCategories.TABLE_TENNIS]: {
    id: sportCategories.TABLE_TENNIS,
    nameId: 'sports.table_tennis',
    purpleSvg: tableTennisPurpleSvg,
    greySvg: tableTennisGreySvg,
    whiteSvg: tableTennisWhiteSvg,
    svg: tableTennisSvg,
    orangeSvg: tableTennisOrangeSvg,
  },
  [sportCategories.VOLLEYBALL]: {
    id: sportCategories.VOLLEYBALL,
    nameId: 'sports.volleyball',
    purpleSvg: volleyballPurpleSvg,
    greySvg: volleyballGreySvg,
    whiteSvg: volleyballWhiteSvg,
    svg: volleyballSvg,
    orangeSvg: volleyballOrangeSvg,
  },
  [sportCategories.GOLF]: {
    id: sportCategories.GOLF,
    nameId: 'sports.golf',
    purpleSvg: golfPurpleSvg,
    greySvg: golfGreySvg,
    whiteSvg: golfWhiteSvg,
    svg: golfSvg,
    orangeSvg: golfOrangeSvg,
  },
  [sportCategories.F1]: {
    id: sportCategories.F1,
    nameId: 'sports.f1',
    purpleSvg: f1PurpleSvg,
    greySvg: f1GreySvg,
    whiteSvg: f1WhiteSvg,
    svg: f1Svg,
    orangeSvg: f1OrangeSvg,
  },
  [sportCategories.GREY_HOUNDS]: {
    id: sportCategories.GREY_HOUNDS,
    nameId: 'sports.greyhounds',
    purpleSvg: greyhoundsPurpleSvg,
    greySvg: greyhoundsGreySvg,
    whiteSvg: greyhoundsWhiteSvg,
    svg: greyhoundsSvg,
    orangeSvg: greyhoundsOrangeSvg,
  },
  [sportCategories.ELEAGUES]: {
    id: sportCategories.ELEAGUES,
    nameId: 'sports.eleagues',
    purpleSvg: eleaguesPurpleSvg,
    greySvg: eleaguesGreySvg,
    whiteSvg: eleaguesWhiteSvg,
    svg: eleaguesSvg,
    orangeSvg: eleaguesOrangeSvg,
  },
  [sportCategories.E_FOOTBALL]: {
    id: sportCategories.E_FOOTBALL,
    nameId: 'sports.efootball',
    purpleSvg: footballPurpleSvg,
    greySvg: footballGreySvg,
    whiteSvg: footballWhiteSvg,
    svg: footballSvg,
    orangeSvg: footballOrangeSvg,
  },
  [sportCategories.E_BASKETBALL]: {
    id: sportCategories.E_BASKETBALL,
    nameId: 'sports.ebasketball',
    purpleSvg: basketballPurpleSvg,
    greySvg: basketballGreySvg,
    whiteSvg: basketballWhiteSvg,
    svg: basketballSvg,
    orangeSvg: basketballOrangeSvg,
  },
};

// sport statuses
export const eventStatuses: Status = {
  UPCOMING: 0,
  LIVE: 1,
  FINISHED: 2,
  CANCELLED: 5,
  ABOUT_TO_START: 6,
};

// ticket statuses
export const ticketResultStatuses: Status = {
  WON: 1,
  LOST: 2,
  PLACED: 9,
  PUSH: 5,
  VOID: 6,
};

// offer statuses
export const offerStatuses: Status = {
  ENABLED: 1,
  DISABLED: 2,
  BETTING_PAUSED: 3,
  NOT_SETTLED: 4,
};

export const offerStatusesForUnavailability = [offerStatuses.DISABLED, offerStatuses.BETTING_PAUSED];

export const ticketStatuses = {
  PENDING: 1,
  ACCEPTED: 2,
  REJECTED: 3,
  CANCELLED: 4,
  RETAINABLE: 5,
};

export const outcomeStatuses = {
  NON_RUNNER: 3,
  BETTABLE: 4,
};

export const TRENDING_BETS_LIMIT_TO_MOVE_TO_TOP = 15;

export const MAX_BETS_IN_ACCA = 20;

export const ALL_MARKETS_GROUP: MarketOfferGroup = {
  id: -1,
  name: 'All',
};

export const SPORTS_PRIORITY_OFFSET = 2;
export const INVALID_SPORT_PRIORITY = -1;

export const BACKEND_LOCALIZED_COUNTRIES = [
  AcceptedCountries.GREAT_BRITAIN,
  AcceptedCountries.KENYA,
  AcceptedCountries.BRAZIL,
  AcceptedCountries.FINLAND,
];

export const COMPETITION_EVENT_LIST_INCREMENT_MOBILE = 3;
export const COMPETITION_EVENT_LIST_INCREMENT_DESKTOP = 5;

export const eventListTypes = [LIST_TYPE.EVENT, LIST_TYPE.RACE, LIST_TYPE.COMPETITION];

export const competitionCalendarTypes = [LIST_TYPE.SUB_NAVIGATION];

export const meetingTypes = [LIST_TYPE.MEETINGS, LIST_TYPE.COMPETITIONS_GET];

export const NUMBER_OF_BOOKED_HR_DISPLAYED_IN_FEATURED_PAGE = 1;

export const OFFER_ID_FALLBACK = 1;

export const liveEventLightModeCardWhitelist = [sportCategories.HORSES, sportCategories.GREY_HOUNDS, sportCategories.GOLF];

export const racingSports = [sportCategories.HORSES, sportCategories.GREY_HOUNDS];

export const MAX_TRENDING_BETS_PER_CARD = 5;
export const MIN_TRENDING_BETS_PER_CARD = 3;
export const MAX_TRENDING_BET_CARDS = 3;
export const TWO_TRENDING_BET_CARDS = 2;
export const ONE_TRENDING_BET_CARD = 1;

export const sportsNotEligibleForLMT = [
  sportCategories.GOLF,
  sportCategories.MMA,
  sportCategories.BOXING,
  sportCategories.HORSES,
  sportCategories.GREY_HOUNDS,
];

export const ELEAGUE_SPORT_IDS = [sportCategories.E_FOOTBALL, sportCategories.E_BASKETBALL];
export const ALL_ELEAGUE_SPORT_IDS = [sportCategories.ELEAGUES, sportCategories.E_FOOTBALL, sportCategories.E_BASKETBALL];

export const betmakersStreamingSports = [sportCategories.HORSES, sportCategories.GREY_HOUNDS];

export const betradarStreamingSports = [sportCategories.E_FOOTBALL];

export const KENYA_FEATURED_FOOTBALL_MAX_CAP = 10;
export const KENYA_FEATURED_BASKETBALL_MAX_CAP = 10;
